import { Heading } from '@/components/atoms/heading';
import { InternalLink } from '@/components/atoms/link/internal-link';

export const CustomerNoToken = () => {
  return (
    <div className="flex flex-col gap-6 rounded-dpDefault bg-dp-white p-8 shadow-dpCard dp-md:w-[400px]">
      <Heading variant="h3">
        You need a registration link to create an account.
      </Heading>
      <InternalLink href="/auth">Go to sign in</InternalLink>
    </div>
  );
};
